<template functional>
  <!-- eslint-disable -->
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 24 24"
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg">
    <path
      d="M21,5.25H17.441c-.9,0-.939-.114-1.186-.854l-.2-.607A2.245,2.245,0,0,0,13.919,2.25H10.081A2.245,2.245,0,0,0,7.947,3.789l-.2.607c-.247.74-.286.854-1.186.854H3a.75.75,0,0,0,0,1.5H4.3l.767,11.5a3.444,3.444,0,0,0,3.742,3.5h6.386a3.444,3.444,0,0,0,3.742-3.5L19.7,6.75H21a.75.75,0,0,0,0-1.5ZM9.37,4.263a.748.748,0,0,1,.711-.513h3.838a.748.748,0,0,1,.711.513l.2.607c.043.131.088.258.136.38H9.031c.048-.123.093-.25.136-.38Zm8.068,13.886a1.973,1.973,0,0,1-2.245,2.1H8.807a1.973,1.973,0,0,1-2.245-2.1L5.8,6.75h.757c.125,0,.228-.013.341-.021A.657.657,0,0,0,7,6.75H17a.657.657,0,0,0,.1-.021c.113.008.216.021.341.021H18.2ZM14.75,11v5a.75.75,0,0,1-1.5,0V11a.75.75,0,0,1,1.5,0Zm-4,0v5a.75.75,0,0,1-1.5,0V11a.75.75,0,0,1,1.5,0Z"/>
  </svg>
</template>

<script>
export default {
  name: 'IconTrash',
};
</script>